import { useSelector } from 'react-redux';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import {
    defaultProcessArtifactResource,
    ProcessArtifactMutationResourceSchema,
    useProcessArtifactActions,
} from '../../../../../resource/resources/artifacts/process_artifact/processArtifactResource';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import { Form_EditableViewWrapper } from '../../../../reusable-components/form-components/Form_EditableViewWrapper';
import { ResourceValidationTitleBar } from '../../../../reusable-components/validation/ResourceValidationTitleBar';
import { ProcessArtifactContent } from './ProcessArtifactContent';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import { Text } from '@mantine/core';

export const ProcessArtifactView = ({ id }: { id: string | undefined }) => {
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const processArtifactActions = useProcessArtifactActions()
    const processArtifactQuery = processArtifactActions.useGetResource(id);
    const updateProcessArtifact = processArtifactActions.useUpdateResource();
    const validateProcessArtifact = processArtifactActions.useValidateResource(id, validationScope);

    const { form, formNames, onSubmit } = useMyForm({
        schema: ProcessArtifactMutationResourceSchema,
        defaultValues: defaultProcessArtifactResource,
        submitHandler: async (data) => {
            await updateProcessArtifact.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: processArtifactQuery.data,
    });

    return (
        <QueryBaseComponent name="ProcessArtifact" query={processArtifactQuery}>
            <Form_EditableViewWrapper form={form} onSubmit={onSubmit}>
                <ResourceValidationTitleBar
                    resourceValidationResult={validateProcessArtifact.data}
                    metaDataInfo={processArtifactQuery.data}
                    resourceType={ResourceType.PROCESS_ARTIFACT}
                >
                    <Text c="dimmed">Process Artifact</Text>
                </ResourceValidationTitleBar>
                <ProcessArtifactContent form={form} formNames={formNames} id={id} readOnly={readOnly} />
            </Form_EditableViewWrapper>
        </QueryBaseComponent>
    );
};
